export default "__VITE_ASSET__99b318c0__"